import React, { useEffect } from "react";

import { Button, Paper } from "@material-ui/core";
import { useMediaQuery } from "react-responsive";

import { Context as InvoicesContext } from "../context/invoices.context";
import { Context as PortalContext } from "../context/portal.context";

import Thousands from "../helpers/Thousands";
import DecimalsOnly from "../helpers/DemicalsOnly";

const ConfirmPaymentBar = (props) => {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });
  const { state } = React.useContext(InvoicesContext);
  const portalState = React.useContext(PortalContext);
  const [amountDropdown, setAmountDropdown] = React.useState(
    state?.amountDropdown[0]
  );
  const [paymentAmount, setPaymentAmount] = React.useState(
    state?.amountDropdown[0]?.amount
  );

  useEffect(() => {
    if (state.amountDropdown.length > 0) {
      // document.getElementById('intellipay-amount-hidden').value = paymentAmount;
      setPaymentAmount(state.amountDropdown[0].amount);
      props.setPaymentTotal(paymentAmount);
      // document.getElementById('intellipay-amount-dropdown').value = state.amountDropdown[0];
    }
  }, []);

  const enableButton = () => {
    
  }

  const xLang = (string) => {
		return string
	}

  function isNumberKey(value) {
    let isnum = /^[0-9]*[.]?[0-9]*$/.test(value);

    return isnum;
  }

  if (!isTabletOrMobile) {
    console.log("Props: %o, %o", props, portalState.state);
    //portalState.state.invoice_interface = "amount";
    return (
      <div style={styles.container}>
        <div style={styles.confirmBox}>
          {portalState.state.invoice_interface !== "amount" ? (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                padding: 25,
                paddingLeft: 0,
              }}
            >
              <span
                style={{
                  fontSize: 20,
                  color:
                    props.amount.toString() === "0" ||
                    props.amount.toString() === "0.00" ||
                    props.amount.toString() === "0.00"
                      ? "#d3dce0"
                      : "#2f343b",
                  fontWeight: 200,
                  marginBottom: 0,
                  marginRight: 40,
                }}
              >
                <x-lang>Confirm Payment</x-lang>
              </span>
              <div style={styles.divider} />
            </div>
          ) : null}
        </div>
        {portalState.state.invoice_interface !== "amount" ? (
          <>
            <div style={styles.confirmBox}>
              <span
                style={{
                  fontSize: 16,
                  marginBottom: 10,
                  color: "#627278",
                }}
              >
                <x-lang>Total Amount</x-lang>
              </span>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  fontWeight: "400",
                  alignItems: "flex-start",
                }}
              >
                <sup
                  style={{
                    fontSize: 25,
                    color:
                      props.amount.toString() === "0" ||
                      props.amount.toString() === "0.00"
                        ? "#d3dce0"
                        : "#2f343b",
                  }}
                >
                  $
                </sup>
                <span
                  style={{
                    color:
                      props.amount.toString() === "0" ||
                      props.amount.toString() === "0.00"
                        ? "#d3dce0"
                        : "#2f343b",
                    fontSize: 30,
                  }}
                >
                  {props.amount.toString() === "0" ||
                  props.amount.toString() === "0.00"
                    ? "0"
                    : Thousands(Math.trunc(props.amount))}
                </span>
                <sup
                  style={{
                    fontSize: 25,
                    color:
                      props.amount.toString() === "0" ||
                      props.amount.toString() === "0.00"
                        ? "#d3dce0"
                        : "#2f343b",
                  }}
                >
                  {props.amount.toString() === "0" ||
                  props.amount.toString() === "0.00"
                    ? ".00"
                    : DecimalsOnly(parseFloat(props.amount))}
                </sup>
              </div>
            </div>

            <div style={styles.confirmBox}>
              <span
                style={{
                  fontSize: 16,
                  marginBottom: 10,
                  color: "#627278",
                }}
              >
                <x-lang>Invoices</x-lang>
              </span>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  fontWeight: "400",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontSize: 30,
                    color:
                      props.amount.toString() === "0" ||
                      props.amount.toString() === "0.00"
                        ? "#d3dce0"
                        : "#2f343b",
                  }}
                >
                  {xLang(props.selectedInvoices)}
                </span>
              </div>
            </div>

            <Button
              // data-ipayname="submit"
              // className="ipayfield"
              variant={"contained"}
              color="secondary"
              disableElevation
              disabled={
                props.oneUnpaidInvoiceChecked === false ||
                (props.amount <= 0 && !portalState.state.allowPartialPayment)
                  ? // ||
                    // props.amount <= 0 ||
                    // props.amount.toString() === '0.00'
                    true
                  : false
              }
              style={styles.payButton}
              //onClick={props.handleOpen}
              onClick={() => window.intellipay.onSubmit()}
            >
             <x-lang> Pay Now</x-lang>
            </Button>
            <input
              className="ipayfield"
              data-ipayname="amount"
              type="hidden"
              value={parseFloat(props.amount).toFixed(2)}
            />
          </>
        ) : (
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <span
              style={{
                fontSize: 20,
                color: "#2f343b",
                fontWeight: 200,
                marginBottom: 25,
                marginTop: 25,
              }}
            >
              <x-lang>Confirm Payment</x-lang>
            </span>
            <div
              style={{
                width: "100%",
              }}
            >
              <select
                onChange={(e) => {
                  console.log("changing", JSON.parse(e.target.value));

                  setAmountDropdown(JSON.parse(e.target.value).description);
                  if (JSON.parse(e.target.value).amount !== 0) {
                    setPaymentAmount(JSON.parse(e.target.value).amount);
                  } else {
                    setPaymentAmount("");
                  }

                  document.getElementById("intellipay-amount-hidden").value =
                    JSON.parse(e.target.value).amount;
                }}
                value={xLang(amountDropdown.description)}
                id="intellipay-amount-dropdown"
                style={{
                  height: 40, 
                  width: "100%",
                  display: "flex",
                  borderRadius: 6,
                  border: "1px solid #d3dce0",
                  boxShadow: "inset 0px 0px 0px 0px",
                  outline: "none",
                  borderStyle: "solid",
                  paddingLeft: 8,
                  paddingRight: 8,
                  fontSize: "1rem",
                  fontWeight: 400,
                  marginBottom: 25,
                }}
              >
                {state.amountDropdown.map((option, index) => {
                  return (
                    <option
                      key={index}
                      value={JSON.stringify(option)}
                      selected={
                        amountDropdown.description === option.description
                      }
                    >
                      {option.description}
                    </option>
                  );
                })}
              </select>
              {/* what is amountDropdown : {amountDropdown} */}
              {amountDropdown === "Pay Other Amount" && (
                <div>
                  <input
                    onChange={(e) => {
                      console.log(e.target.value);
                      if (isNumberKey(e.target.value)) {
                        setPaymentAmount(e.target.value);
                        document.getElementById(
                          "intellipay-amount-hidden"
                        ).value = e.target.value;
                      }
                      // setAmountDropdown(e.target.value);
                    }}
                    value={paymentAmount}
                    placeholder="Enter amount (eg. 1.23)"
                    id="intellipay-other-amount-field"
                    style={{
                      height: 40,
                      borderRadius: 6,
                      width: "100%",
                      border: "1px solid #d3dce0",
                      boxShadow: "inset 0px 0px 0px 0px",
                      boxSizing: "border-box",
                      outline: "none",
                      borderStyle: "solid",
                      paddingLeft: 8,
                      paddingRight: 8,
                      fontSize: "1rem",
                      fontWeight: 400,
                      marginBottom: 25,
                    }}
                    onBlur={() => {
                      if (paymentAmount !== "") {
                        setPaymentAmount(parseFloat(paymentAmount).toFixed(2));
                      }
                    }}
                  />
                </div>
              )}
            </div>
            {amountDropdown === "Pay Other Amount" ? (
              <Button
                // data-ipayname="submit"
                // className="ipayfield"
                variant={"contained"}
                color="secondary"
                disableElevation
                disabled={paymentAmount === "" ? true : false}
                style={{
                  ...styles.payButton,
                  marginBottom: 25,
                }}
                //onClick={props.handleOpen}
                onClick={() => window.intellipay.onSubmit()}
              >
                <x-lang>Pay Now</x-lang>
              </Button>
            ) : (
              <Button
                // data-ipayname="submit"
                // className="ipayfield"
                variant={"contained"}
                color="secondary"
                disableElevation
                style={{
                  ...styles.payButton,
                  marginBottom: 25,
                }}
                //onClick={props.handleOpen}
                onClick={() => window.intellipay.onSubmit()}
              >
                <x-lang>Pay Now</x-lang>
              </Button>
            )}
          </div>
        )}
      </div>
    );
  } else {
    return (
      <>
      {portalState.state.invoice_interface === "amount" &&
      <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }}
    >
      <span
        style={{
          fontSize: 20,
          color: "#2f343b",
          fontWeight: 200,
          marginBottom: 25,
          marginTop: 25,
        }}
      >
        <x-lang>Confirm Payment</x-lang>
      </span>
      <div
        style={{
          width: "100%",
        }}
      >
        <select
          onChange={(e) => {
            console.log("changing", JSON.parse(e.target.value));

            setAmountDropdown(JSON.parse(e.target.value).description);
            if (JSON.parse(e.target.value).amount !== 0) {
              setPaymentAmount(JSON.parse(e.target.value).amount);
            } else {
              setPaymentAmount("");
            }

            document.getElementById("intellipay-amount-hidden").value =
              JSON.parse(e.target.value).amount;
          }}
          value={xLang(amountDropdown.description)}
          id="intellipay-amount-dropdown"
          style={{
            height: 40,
            width: "100%",
            display: "flex",
            borderRadius: 6,
            border: "1px solid #d3dce0",
            boxShadow: "inset 0px 0px 0px 0px",
            outline: "none",
            borderStyle: "solid",
            paddingLeft: 8,
            paddingRight: 8,
            fontSize: "1rem",
            fontWeight: 400,
            marginBottom: 25,
          }}
        >
          {state.amountDropdown.map((option, index) => {
            return (
              <option
                key={index}
                value={JSON.stringify(option)}
                selected={
                  amountDropdown.description === option.description
                }
              >
                {xLang(option.description)}
              </option>
            );
          })}
        </select>
        {/* what is amountDropdown : {amountDropdown} */}
        {amountDropdown === "Pay Other Amount" && (
          <div>
            <input
              onChange={(e) => {
                console.log(e.target.value);
                if (isNumberKey(e.target.value)) {
                  setPaymentAmount(e.target.value);
                  document.getElementById(
                    "intellipay-amount-hidden"
                  ).value = e.target.value;
                }
                // setAmountDropdown(e.target.value);
              }}
              value={paymentAmount}
              placeholder="Enter amount (eg. 1.23)"
              id="intellipay-other-amount-field"
              style={{
                height: 40,
                borderRadius: 6,
                width: "100%",
                border: "1px solid #d3dce0",
                boxShadow: "inset 0px 0px 0px 0px",
                boxSizing: "border-box",
                outline: "none",
                borderStyle: "solid",
                paddingLeft: 8,
                paddingRight: 8,
                fontSize: "1rem",
                fontWeight: 400,
                marginBottom: 25,
              }}
              onBlur={() => {
                if (paymentAmount !== "") {
                  setPaymentAmount(parseFloat(paymentAmount).toFixed(2));
                }
              }}
            />
          </div>
        )}
      </div>
    </div>
      
      }
      <Paper
        style={{
          height: 100,
          width: "100vw",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          position: "fixed",
          bottom: 70,
          left: 0,
          zIndex: 1000,
          boxSizing: "border-box",
          paddingLeft: 25,
          paddingRight: 25,
          background: `linear-gradient(to right,${props.theme.palette.primary.main},${props.theme.palette.welcomeBar.right})`,
        }}
        elevation={5}
      >
        <div>
          <h5 style={{ color: "#fbfbfb", margin: 0, marginBottom: 5 }}>
          <x-lang>Total Amount</x-lang>
          </h5>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              fontWeight: "400",
              alignItems: "flex-start",
            }}
          >
            <sup
              style={{
                fontSize: 20,
                color: "white",
              }}
            >
              $
            </sup>
            {
              portalState.state.invoice_interface === "amount" ? (<span  style={{
                color: "white",
                fontSize: 25,
              }}>{paymentAmount}</span>) : (<>  <span
                style={{
                  color: "white",
                  fontSize: 25,
                }}
              >
                {props.amount.toString() === "0" ||
                props.amount.toString() === "0.00"
                  ? "0"
                  : Thousands(Math.trunc(props.amount))}
              </span>
               <sup
               style={{
                 fontSize: 20,
                 color: "white",
               }}
             >
               .
               {props.amount.toString() === "0" ||
               props.amount.toString() === "0.00"
                 ? "00"
                 : props.amount.toString().split(".")[1]}
             </sup></>)
            }
            {/* <span
              style={{
                color: "white",
                fontSize: 25,
              }}
            >
              {props.amount.toString() === "0" ||
              props.amount.toString() === "0.00"
                ? "0"
                : Thousands(Math.trunc(props.amount))}
            </span> */}
           
          </div>
        </div>
        <div>
          <h5 style={{ color: "#fbfbfb", margin: 0, marginBottom: 5 }}>
          <x-lang>Invoices</x-lang>
          </h5>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              fontWeight: "400",
              alignItems: "center",
            }}
          >
            <span
              style={{
                fontSize: 25,
                color: "white",
              }}
            >
              {xLang(props.selectedInvoices)}
            </span>
          </div>
        </div>
        <Button
          variant="contained"
          color="secondary"
          data-ipayname="submit"
          className="ipayfield"
          disabled={
            (props.selectedInvoices > 0 || portalState.state.invoice_interface === "amount") && paymentAmount > 0.00 ? false : true
          }
          style={{ color: "white", borderRadius: 25 }}
          onClick={() => window.intellipay.onSubmit()}
        >
          <x-lang>Pay</x-lang>
        </Button>
      </Paper>
      </>
    );
  }
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    background: "white",
    paddingLeft: 50,
    paddingRight: 50,
    border: "1px solid #e3e6e7",
    borderRadius: 5,
  },
  containerMobile: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    background: "white",
    padding: 40,
    border: "1px solid #e3e6e7",
    borderRadius: 5,
  },
  payButton: {
    height: 40,
    color: "white",
    borderRadius: 20,
    width: 150,
    marginBottom: 0,
  },
  confirmBox: {
    display: "flex",
    flexDirection: "column",
  },
  invoicesAmount: {
    background: "rgba(185,217,235,.4)",
    padding: 10,
    borderRadius: 20,
    width: 150,
  },
  divider: {
    height: 60,
    width: 1,
    background: "#e3e6e7",
  },
};

export default ConfirmPaymentBar;
